import { svg } from "lit";
const icon = svg `<path d="M15.4998 12.2115L17.2882 14V15.5H12.7498V20.9999L11.9998 21.7499L11.2499 20.9999V15.5H6.71143V14L8.49985 12.2115V4.99998H7.49985V3.5H16.4998V4.99998H15.4998V12.2115ZM8.84983 14H15.1498L13.9998 12.85V4.99998H9.99983V12.85L8.84983 14Z" fill="currentColor"/>`;
export default icon;
